import React, { useState, useRef, useEffect } from 'react'

const Panel = ({ show, hideContentsWhenCollapsed=true, children }) => {
  const [ showState, setShowState ] = useState(show ? 'show' : 'hide')
  const panel = useRef()
  const measure = useRef()
  const mounted = useRef()

  useEffect(() => {
    if (!mounted.current) return

    const timeouts = []
    timeouts.push(setTimeout(() => setShowState(show ? 'expand' : 'collapse'), 10))
    timeouts.push(setTimeout(() => panel.current.scrollTo(0, 0), 76))
    timeouts.push(setTimeout(() => setShowState(show ? 'expanding' : 'collapsing'), 76))
    timeouts.push(setTimeout(() => setShowState(show ? 'show' : 'hide'), 610))

    return () => timeouts.forEach(clearTimeout)
  }, [ show ])

  useEffect(() => {
    mounted.current = true
    return () => mounted.current = false
  }, [])

  return (
    <div ref={panel} className="overflow-hidden mx-n3" style={{
      transition: [ 'show', 'hide' ].indexOf(showState) > -1
                  ? '' : 'height 0.5s, opacity 0.5s',
      height: (() => {
        switch (showState) {
          case 'show':
            return 'auto'
          case 'collapse':
          case 'expanding':
            return measure.current.offsetHeight + 'px'
          case 'expand':
          case 'collapsing':
          case 'hide':
            return 0
        }
      })(),
      opacity: (() => {
        switch (showState) {
          case 'show':
          case 'collapse':
          case 'expanding':
            return 1
          case 'expand':
          case 'collapsing':
          case 'hide':
            return 0
        }
      })()
    }}>
      <div className="overflow-hidden px-3" ref={measure}>
        { showState == 'hide' && hideContentsWhenCollapsed ? null : children }
      </div>
    </div>
  )
}

export default Panel
